import { Link } from "react-router-dom";
import styled from "styled-components";

export const Logo = styled<any>(Link)`
  text-decoration: none;
  color: black;
  display: flex;
`;
